export enum UserRolesEnum {
  ADMIN = 'ADMIN',
  ASSET_MANAGER = 'ASSET_MANAGER',
  REPORTING = 'REPORTING',
}
